import FundPreviewList from './FundPreviewList'

export default FundPreviewList
